import { render, staticRenderFns } from "./TaxReturnClients.vue?vue&type=template&id=6afa064e&"
import script from "./TaxReturnClients.vue?vue&type=script&lang=js&"
export * from "./TaxReturnClients.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports